<template>
  <v-card rounded="lg" height="600px">
    <v-card-title class="d-flex justify-space-between align-center py-6">
      <div class="">
        <div class="text-h5 font-weight-black">
          <div class="">{{ formName }}</div>
        </div>
        <p>{{ questionLang1 }}</p>
      </div>
      <v-btn icon="mdi-close" variant="text" @click="closeModal" size="x-large"></v-btn>
    </v-card-title>
    <v-card-text class="overflow-y-auto pt-0">
      <v-list class="pt-0" lines="three">
        <v-list-item class="text-center" v-if="responsesByPage.length === 0">{{ $t('i18n.noResponsesText') }}</v-list-item>
        <v-list-item class="pt-0" v-for="(response, index) in responsesByPage" :key="index">
          <v-list-item-subtitle class="pb-2">{{ formatDate(response.submission_date) }}</v-list-item-subtitle>
          <v-list-item-title>{{ response.value }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-pagination
      :length="totalPages"
      rounded="circle"
      v-model="selectedPageNumber"
      @update:modelValue="getPaginatedResponses"
    ></v-pagination>
  </v-card>
</template>

<script lang="ts">
import { Response } from '@/utils/DataTypes'
import { api, getDateTime } from '@/utils/HelperFunctions'
import { ComputedRef, defineComponent, inject } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/appStore'
import dayjs from 'dayjs'

export default defineComponent({
  name: 'TextInputResponses',
  setup () {
    const router = useRouter()
    const appStore = useAppStore()
    const dateRange = inject('dateRange') as ComputedRef<{ startDate: Date, endDate: Date }> | null
    return {
      router,
      appStore,
      dateRange
    }
  },
  props: {
    formName: {
      type: String,
      required: true,
      default: ''
    },
    formItemID: {
      type: Number,
      required: true
    },
    questionLang1: {
      type: String,
      required: true
    }
  },
  async mounted () {
    await this.getPaginatedResponses()
    this.loading = false
  },
  data () {
    return {
      filters: {
        value: ''
      },

      responsesByPage: [] as Array<Response>,

      selectedPageNumber: 1,
      responsesPerPage: 5,
      totalPages: 1,

      filterActive: false,
      loading: true
    }
  },
  methods: {

    async getPaginatedResponses () {
      try {
        this.loading = true
        const queryParams: Record<string, any> = {
          page: this.selectedPageNumber,
          limit: this.responsesPerPage,
          startDate: dayjs().startOf('day').toISOString(),
          endDate: dayjs().endOf('day').toISOString()
        }

        const url = `/form-response/${this.formItemID}?page=${queryParams.page}&limit=${queryParams.limit}&startDate=${queryParams.startDate}&endDate=${queryParams.endDate}`
        const getPaginatedResponses = await api(url, 'get', null)

        if (!getPaginatedResponses) return

        this.responsesByPage = getPaginatedResponses.data[0].responseList
        this.totalPages = getPaginatedResponses.data[0].paginationData.totalPages
      } catch (error) {
        this.appStore.addAlert('error', 'Couldn\'t get response list.')
      } finally {
        this.loading = false
      }
    },
    navigate (routeName: string) {
      this.router.push({ name: routeName })
    },
    closeModal () {
      this.$emit('close-modal')
    },
    formatDate (dateStr: string): string {
      return getDateTime(dateStr)
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../../styles/colors.scss";
</style>
